import {
  BadgeDollarSign,
  Barcode,
  BookOpen,
  Building2,
  ClipboardList,
  CloudDownload,
  Container,
  FileCheck,
  FilePen,
  FilePlus,
  FileSearch,
  FileText,
  Gauge,
  Hash,
  IdCard,
  type LucideIcon,
  Mail,
  MessageSquare,
  Pencil,
  Plug,
  Plus,
  Search,
  Send,
  ShieldCheck,
  StickyNote,
  Target,
  Trash2,
  TriangleAlert,
  Truck,
  Users,
  Wrench,
} from 'lucide-react'

/**
 * Kebab-case lucide name -> component, for the icon the backend picks per
 * tool. The vocabulary is defined server-side in
 * `backend/insure/services/agent/mcp_tools_config.py` (`icon_for_tool`); keep the two
 * in sync when adding one. An unknown name falls back to the default rather
 * than rendering nothing, so a backend-only addition degrades quietly.
 */
export const TOOL_ICONS: Partial<Record<string, LucideIcon>> = {
  'badge-dollar-sign': BadgeDollarSign,
  barcode: Barcode,
  'book-open': BookOpen,
  'building-2': Building2,
  'clipboard-list': ClipboardList,
  'cloud-download': CloudDownload,
  container: Container,
  'file-check': FileCheck,
  'file-pen': FilePen,
  'file-plus': FilePlus,
  'file-search': FileSearch,
  'file-text': FileText,
  gauge: Gauge,
  hash: Hash,
  'id-card': IdCard,
  mail: Mail,
  'message-square': MessageSquare,
  pencil: Pencil,
  plug: Plug,
  plus: Plus,
  search: Search,
  send: Send,
  'shield-check': ShieldCheck,
  'sticky-note': StickyNote,
  target: Target,
  'trash-2': Trash2,
  'triangle-alert': TriangleAlert,
  truck: Truck,
  users: Users,
  wrench: Wrench,
}

export const DEFAULT_TOOL_ICON = Wrench
